// 전역 푸터(사업자 정보 + 약관/방침/환불 링크). 모든 메인 레이아웃 화면 하단에 노출.
// PG/카드사 심사 요건: 사업자 정보·이용약관·개인정보처리방침·환불정책이 사이트에서 쉽게 확인돼야 한다.

import { Link } from "react-router-dom";
import { BUSINESS_INFO } from "./businessInfo.ts";

// 전역 푸터(사업자정보 + 약관/방침/환불 링크).
export default function SiteFooter() {
  return (
    <footer className="border-t border-ink-200 bg-ink-50 px-5 py-6 text-xs leading-relaxed text-ink-600">
      {/* 정책 링크 */}
      <nav className="mb-3 flex flex-wrap gap-x-4 gap-y-1">
        <Link to="/legal/terms" className="font-medium text-ink-700 underline">
          이용약관
        </Link>
        <Link to="/legal/privacy" className="font-medium text-ink-700 underline">
          개인정보처리방침
        </Link>
        <Link to="/legal/refund" className="font-medium text-ink-700 underline">
          취소·환불·교환
        </Link>
        <Link to="/legal/business" className="font-medium text-ink-700 underline">
          사업자정보
        </Link>
      </nav>

      {/* 사업자 정보 요약 */}
      <div className="flex flex-col gap-0.5">
        <p className="font-semibold text-ink-700">{BUSINESS_INFO.name}</p>
        <p>
          대표 {BUSINESS_INFO.ceo} · 사업자등록번호 {BUSINESS_INFO.bizRegNo}
        </p>
        {BUSINESS_INFO.ecommerceRegNo ? (
          <p>통신판매업 신고 {BUSINESS_INFO.ecommerceRegNo}</p>
        ) : null}
        <p>{BUSINESS_INFO.address}</p>
        <p>
          고객문의 {BUSINESS_INFO.tel} · {BUSINESS_INFO.email}
        </p>
      </div>
      <p className="mt-3 text-ink-500">
        결제는 (주)포트원 및 한국결제네트웍스(KPN)를 통해 안전하게 처리됩니다.
      </p>
    </footer>
  );
}
